module.exports = __webpack_public_path__ + "static/media/umar.cd493a89.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/pics/umar.png
// module id = 146
// module chunks = 0